import { CmsVendor } from "@gatsbyjs/graphql/types"
import {
  AgilityLogo,
  ButtercmsLogo,
  ContentstackLogo,
  ContentfulLogo,
  CosmicLogo,
  DatocmsLogo,
  DrupalLogo,
  FlotiqLogo,
  PrismicLogo,
  SanityLogo,
  ShopifyLogo,
  StoryblokLogo,
  StrapiLogo,
  WordpressLogo,
  GraphcmsLogo,
  LogoProps,
} from "gatsby-ui/src/components/icons/logos"

import { FiLayers } from "react-icons/fi"

export type SupportedCmsVendor =
  | CmsVendor.Contentful
  | CmsVendor.Cosmicjs
  | CmsVendor.Datocms
  | CmsVendor.Drupal
  | CmsVendor.Sanity
  | CmsVendor.Shopify
  | CmsVendor.Wordpress
  | CmsVendor.None
  | CmsVendor.Custom
  | CmsVendor.DataSync

export const dataSourceNames: {
  [key: string]: string
} = {
  [CmsVendor.Agility]: `Agility`,
  [CmsVendor.Butter]: `ButterCMS`,
  [CmsVendor.Contentstack]: `Contentstack`,
  [CmsVendor.Contentful]: `Contentful`,
  [CmsVendor.Cosmicjs]: `Cosmic`,
  [CmsVendor.Datocms]: `DatoCMS`,
  [CmsVendor.Drupal]: `Drupal`,
  [CmsVendor.Flotiq]: `Flotiq`,
  GRAPHCMS: `GraphCMS`,
  [CmsVendor.Sanity]: `Sanity`,
  [CmsVendor.Shopify]: `Shopify`,
  [CmsVendor.Storyblok]: `Storyblok`,
  [CmsVendor.Strapi]: `Strapi`,
  [CmsVendor.Storyblok]: `Storyblok`,
  [CmsVendor.Prismic]: `Prismic`,
  [CmsVendor.Wordpress]: `WordPress`,
  [CmsVendor.None]: `Sourcing all data`,
  [CmsVendor.Custom]: `Building Valhalla Schema`,
  [CmsVendor.DataSync]: `Syncing Data to Valhalla API`,
}

export const systemEvents = [
  CmsVendor.None,
  CmsVendor.Custom,
  CmsVendor.DataSync,
]
export const systemEventNames = systemEvents.map(e => dataSourceNames[e])
export const dataSourceLogos: {
  [key: string]: (props: LogoProps) => JSX.Element
} = {
  [CmsVendor.Agility]: AgilityLogo,
  [CmsVendor.Butter]: ButtercmsLogo,
  [CmsVendor.Contentstack]: ContentstackLogo,
  [CmsVendor.Contentful]: ContentfulLogo,
  [CmsVendor.Cosmicjs]: CosmicLogo,
  [CmsVendor.Datocms]: DatocmsLogo,
  [CmsVendor.Drupal]: DrupalLogo,
  [CmsVendor.Flotiq]: FlotiqLogo,
  GRAPHCMS: GraphcmsLogo,
  [CmsVendor.Prismic]: PrismicLogo,
  [CmsVendor.Sanity]: SanityLogo,
  [CmsVendor.Shopify]: ShopifyLogo,
  [CmsVendor.Storyblok]: StoryblokLogo,
  [CmsVendor.Strapi]: StrapiLogo,
  [CmsVendor.Wordpress]: WordpressLogo,
  [CmsVendor.None]: FiLayers,
  [CmsVendor.Custom]: FiLayers,
  [CmsVendor.DataSync]: FiLayers,
}

export const manualIntegrations = [
  {
    name: dataSourceNames[CmsVendor.Wordpress],
    vendor: CmsVendor.Wordpress,
    logo: dataSourceLogos[CmsVendor.Wordpress],
    docsPath: `/wordpress/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Drupal],
    vendor: CmsVendor.Drupal,
    logo: dataSourceLogos[CmsVendor.Drupal],
    docsPath: `/drupal/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Contentstack],
    vendor: CmsVendor.Contentstack,
    logo: dataSourceLogos[CmsVendor.Contentstack],
    docsPath: `/contentstack/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Sanity],
    vendor: CmsVendor.Sanity,
    logo: dataSourceLogos[CmsVendor.Sanity],
    docsPath: `/sanity/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Prismic],
    vendor: CmsVendor.Prismic,
    logo: dataSourceLogos[CmsVendor.Prismic],
    docsPath: `/cloud/prismic-cms/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Strapi],
    vendor: CmsVendor.Strapi,
    logo: dataSourceLogos[CmsVendor.Strapi],
    docsPath: `/strapi/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Storyblok],
    vendor: CmsVendor.Storyblok,
    logo: dataSourceLogos[CmsVendor.Storyblok],
    docsPath: `/storyblok/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Butter],
    vendor: CmsVendor.Butter,
    logo: dataSourceLogos[CmsVendor.Butter],
    docsPath: `/buttercms/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Agility],
    vendor: CmsVendor.Agility,
    logo: dataSourceLogos[CmsVendor.Agility],
    docsPath: `/agility-cms/getting-started/`,
  },
  {
    name: dataSourceNames[CmsVendor.Flotiq],
    vendor: CmsVendor.Flotiq,
    logo: dataSourceLogos[CmsVendor.Flotiq],
    docsPath: `/flotiq/getting-started/`,
  },
  {
    name: `Graph CMS`,
    logo: dataSourceLogos.GRAPHCMS,
    docsPath: `/graph-cms/getting-started/`,
  },
]

export const dataLayerReadyIntegrations = [
  CmsVendor.Wordpress,
  CmsVendor.Drupal,
  CmsVendor.Contentful,
]

export const GATSBY_VERSION_FOR_DATA_LAYER = `>=4.24.6`
